import { render, staticRenderFns } from "./GeneralStuff.vue?vue&type=template&id=9393e3dc&scoped=true&"
import script from "./GeneralStuff.vue?vue&type=script&lang=js&"
export * from "./GeneralStuff.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStuff.vue?vue&type=style&index=0&id=9393e3dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9393e3dc",
  null
  
)

export default component.exports